import Breadcrumbs from "@mui/material/Breadcrumbs";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { emphasize, styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useContext, useEffect, useRef, useState } from "react";
import Rating from "@mui/material/Rating";
import { FaCloudUploadAlt } from "react-icons/fa";
import Button from "@mui/material/Button";
import {
  deleteData,
  deleteImages,
  fetchDataFromApi,
  postData,
  uploadImage,
} from "../../utils/api";
import { MyContext } from "../../App";
import CircularProgress from "@mui/material/CircularProgress";
import { FaRegImages } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IoCloseSharp } from "react-icons/io5";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import imageCompression from 'browser-image-compression';
import { 
  FormControlLabel, 
  Switch, 
  Box, 
  Typography, 
  Accordion, 
  AccordionSummary, 
  AccordionDetails, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  IconButton, 
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Card,
  CardContent,
  CardHeader,
  InputAdornment,
  TextField,
  Chip as MuiChip,
  Badge,
  Alert,
  Tabs,
  Tab,
  Stack,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Checkbox,
  ListItemSecondaryAction
} from "@mui/material";
import { MdAdd, MdDelete, MdEdit, MdImage, MdInventory } from "react-icons/md";
import { FiPackage, FiEdit3, FiCamera } from "react-icons/fi";
import { BiImageAdd, BiMoney } from "react-icons/bi";
import { AiOutlineLink, AiOutlineUnorderedList } from "react-icons/ai";
import CountryDropdown from "../../components/CountryDropdown";
import Select2 from "react-select";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey;
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ProductUpload = () => {
  const [categoryVal, setcategoryVal] = useState("");
  const [subCatVal, setSubCatVal] = useState("");
  const [productRams, setProductRAMS] = useState([]);
  const [productWeight, setProductWeight] = useState([]);
  const [productSize, setProductSize] = useState([]);
  const [productRAMSData, setProductRAMSData] = useState([]);
  const [productWEIGHTData, setProductWEIGHTData] = useState([]);
  const [productSIZEData, setProductSIZEData] = useState([]);
  const [ratingsValue, setRatingValue] = useState(1);
  const [isFeaturedValue, setisFeaturedValue] = useState("");
  const [catData, setCatData] = useState([]);
  const [subCatData, setSubCatData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  // FIXED: Separate image states to prevent mixing
  const [mainPreviews, setMainPreviews] = useState([]);
  const [variantImagePreviews, setVariantImagePreviews] = useState({});
  
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [isImageRemove, setIsImageRemove] = useState(false);
  const history = useNavigate();

  // Enhanced Variant states
  const [hasVariants, setHasVariants] = useState(false);
  const [variantOptions, setVariantOptions] = useState([
    { 
      name: "", 
      values: [
        {
          value: "",
          images: [],
          price: "",
          oldPrice: "",
          stock: "",
          sku: "",
          isActive: true,
          discount: 0
        }
      ]
    }
  ]);
  const [variants, setVariants] = useState([]);
  const [uploadingOptionImages, setUploadingOptionImages] = useState({});
  const [uploadingVariantImages, setUploadingVariantImages] = useState({});

  // ========== ALTERNATIVE PRODUCTS STATES ==========
  const [alternativeProducts, setAlternativeProducts] = useState([]);
  const [openAlternativeDialog, setOpenAlternativeDialog] = useState(false);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [searchAlternative, setSearchAlternative] = useState("");
  const [loadingAlternatives, setLoadingAlternatives] = useState(false);
  // =================================================

  // Enhanced form fields
  const [formFields, setFormFields] = useState({
    name: "",
    subCat: "",
    subCatName: "",
    description: "",
    brand: "",
    price: null,
    oldPrice: null,
    subCatId: "",
    catName: "",
    catId: "",
    category: "",
    countInStock: null,
    rating: 0,
    isFeatured: null,
    discount: null,
    productRam: [],
    size: [],
    productWeight: [],
    location: [],
    additionalInfo: [],
    specification: [],
    hasVariants: false,
    variantOptions: [],
    variants: [],
  });

  const productImages = useRef();
  const context = useContext(MyContext);
  const formdata = new FormData();

  // Auto-calculate discount function
  const calculateDiscount = (currentPrice, mrp) => {
    if (!currentPrice || !mrp || currentPrice >= mrp) return 0;
    return Math.round(((mrp - currentPrice) / mrp) * 100);
  };

  // Auto-fill form based on name
  const autoFillForm = (productName) => {
    if (!productName.trim()) return;

    const baseSku = productName
      .toLowerCase()
      .replace(/[^a-zA-Z0-9]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

    const updatedFields = {
      ...formFields,
      name: productName,
    };

    if (hasVariants && variants.length > 0) {
      const updatedVariants = variants.map(variant => ({
        ...variant,
        sku: `${baseSku}-${variant.combination.map(c => c.value.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')).join('-')}`
      }));
      setVariants(updatedVariants);
    }

    setFormFields(updatedFields);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setCatData(context.catData);

    // Clear any existing uploaded images at start
    fetchDataFromApi("/api/imageUpload").then((res) => {
      res?.forEach((item) => {
        item?.images?.forEach((img) => {
          deleteImages(`/api/products/deleteImage?img=${img}`).then(() => {
            // Don't delete all uploads here, just individual cleanup
          });
        });
      });
      // Clear the imageUpload collection
      deleteData("/api/imageUpload/deleteAllImages");
    });  

    fetchDataFromApi("/api/productWeight").then((res) => { 
      setProductWEIGHTData(res);
    });
    fetchDataFromApi("/api/productRAMS").then((res) => {
      setProductRAMSData(res);
    });
    fetchDataFromApi("/api/productSIZE").then((res) => {
      setProductSIZEData(res);
    });
  }, []);

  useEffect(() => {
    const newData = { value: 'All', label: 'All' };
    const updatedArray = [...(context?.countryList || [])];
    updatedArray.unshift(newData);
    setCountryList(updatedArray);
  }, [context?.countryList]);

  useEffect(() => {
    formFields.location = context.selectedCountry;
  }, [context.selectedCountry]);



  // Enhanced Variant functions
  const handleVariantToggle = (event) => {
    const isEnabled = event.target.checked;
    setHasVariants(isEnabled);
    setFormFields(prev => ({ ...prev, hasVariants: isEnabled }));
    
    if (!isEnabled) {
      setVariantOptions([
        { 
          name: "", 
          values: [
            {
              value: "",
              images: [],
              price: "",
              oldPrice: "",
              stock: "",
              sku: "",
              isActive: true,
              discount: 0
            }
          ]
        }
      ]);
      setVariants([]);
      setVariantImagePreviews({});
    }
  };

  const addVariantOption = () => {
    setVariantOptions(prev => [
      ...prev, 
      { 
        name: "", 
        values: [
          {
            value: "",
            images: [],
            price: "",
            oldPrice: "",
            stock: "",
            sku: "",
            isActive: true,
            discount: 0
          }
        ]
      }
    ]);
  };

  const removeVariantOption = (index) => {
    const newOptions = variantOptions.filter((_, i) => i !== index);
    setVariantOptions(newOptions);
    generateVariants(newOptions);
  };

  const updateVariantOptionName = (index, name) => {
    const newOptions = [...variantOptions];
    newOptions[index].name = name;
    setVariantOptions(newOptions);
    generateVariants(newOptions);
  };

  const updateVariantOptionValue = (optionIndex, valueIndex, field, value) => {
    const newOptions = [...variantOptions];
    
    if (field === 'value') {
      newOptions[optionIndex].values[valueIndex].value = value;
      if (formFields.name && value) {
        const baseSku = formFields.name
          .toLowerCase()
          .replace(/[^a-zA-Z0-9]/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');
        newOptions[optionIndex].values[valueIndex].sku = `${baseSku}-${value.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')}`;
      }
    } else if (field === 'price' || field === 'oldPrice' || field === 'stock') {
      newOptions[optionIndex].values[valueIndex][field] = value === "" ? "" : Number(value);
      
      if (field === 'price' || field === 'oldPrice') {
        const currentPrice = field === 'price' ? Number(value) : Number(newOptions[optionIndex].values[valueIndex].price);
        const mrp = field === 'oldPrice' ? Number(value) : Number(newOptions[optionIndex].values[valueIndex].oldPrice);
        newOptions[optionIndex].values[valueIndex].discount = calculateDiscount(currentPrice, mrp);
      }
    } else {
      newOptions[optionIndex].values[valueIndex][field] = value;
    }
    
    setVariantOptions(newOptions);
    if (field === 'value') {
      generateVariants(newOptions);
    }
  };

  const addVariantOptionValue = (optionIndex) => {
    const newOptions = [...variantOptions];
    newOptions[optionIndex].values.push({
      value: "",
      images: [],
      price: "",
      oldPrice: "",
      stock: "",
      sku: "",
      isActive: true,
      discount: 0
    });
    setVariantOptions(newOptions);
  };

  const removeVariantOptionValue = (optionIndex, valueIndex) => {
    const newOptions = [...variantOptions];
    newOptions[optionIndex].values = newOptions[optionIndex].values.filter((_, i) => i !== valueIndex);
    setVariantOptions(newOptions);
    generateVariants(newOptions);
  };

  // FIXED: Completely rewritten variant option image upload function
  const onChangeOptionValueFile = async (e, optionIndex, valueIndex) => {
    try {
      const files = e.target.files;
      if (!files || files.length === 0) return;

      // Create unique loading key
      const loadingKey = `${optionIndex}-${valueIndex}`;
      setUploadingOptionImages(prev => ({ ...prev, [loadingKey]: true }));

      const compressionOptions = {
        maxSizeMB: 0.03,
        useWebWorker: true,
        alwaysKeepResolution: true,
        initialQuality: 0.3,
      };

      // Process all files and collect URLs directly
      const newImageUrls = [];
      
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        
        if (!file || !(
          file.type === "image/jpeg" ||
          file.type === "image/jpg" ||
          file.type === "image/png" ||
          file.type === "image/webp"
        )) {
          context.setAlertBox({
            open: true,
            error: true,
            msg: "Please select valid image files (JPG, PNG, WEBP).",
          });
          continue;
        }

        try {
          // Compress image
          const compressedFile = await imageCompression(file, compressionOptions);
          
          // Create individual FormData for each image
          const singleImageFormData = new FormData();
          const renamedFile = new File(
            [compressedFile],
            `variant_${optionIndex}_${valueIndex}_${i}_${Date.now()}.${file.type.split('/')[1]}`,
            { type: compressedFile.type }
          );
          singleImageFormData.append('images', renamedFile);

          // Upload single image
          const uploadResponse = await uploadImage(`/api/products/upload`, singleImageFormData);
          
          if (uploadResponse && uploadResponse.success) {
            // Get the uploaded image URL directly from response
            const imageUploadResponse = await fetchDataFromApi(`/api/imageUpload`);
            
            if (imageUploadResponse && imageUploadResponse.length > 0) {
              const latestUpload = imageUploadResponse[imageUploadResponse.length - 1];
              const uploadedImages = latestUpload?.images || [];
              
              // Add only new URLs
              uploadedImages.forEach(imgUrl => {
                if (!newImageUrls.includes(imgUrl)) {
                  newImageUrls.push(imgUrl);
                }
              });

              // Clean up immediately after getting URLs
              await deleteData("/api/imageUpload/deleteAllImages");
            }
          }
        } catch (compressionError) {
          console.error('Image processing error:', compressionError);
          context.setAlertBox({
            open: true,
            error: true,
            msg: `Failed to process image ${i + 1}`,
          });
        }
      }

      // Update variant options with new images ONLY ONCE
      if (newImageUrls.length > 0) {
        const updatedOptions = [...variantOptions];
        
        // Ensure images array exists
        if (!updatedOptions[optionIndex].values[valueIndex].images) {
          updatedOptions[optionIndex].values[valueIndex].images = [];
        }
        
        // Add new images without duplicates
        newImageUrls.forEach(imgUrl => {
          if (!updatedOptions[optionIndex].values[valueIndex].images.includes(imgUrl)) {
            updatedOptions[optionIndex].values[valueIndex].images.push(imgUrl);
          }
        });
        
        setVariantOptions(updatedOptions);
        generateVariants(updatedOptions);

        context.setAlertBox({
          open: true,
          error: false,
          msg: `${newImageUrls.length} variant images uploaded successfully!`,
        });
      }

      // Clear loading state
      setUploadingOptionImages(prev => ({ ...prev, [loadingKey]: false }));

    } catch (error) {
      console.error('Variant image upload error:', error);
      const loadingKey = `${optionIndex}-${valueIndex}`;
      setUploadingOptionImages(prev => ({ ...prev, [loadingKey]: false }));
      
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Failed to upload variant images. Please try again.",
      });
    }
  };

  const generateVariants = (options) => {
    const validOptions = options.filter(option => 
      option.name.trim() && option.values.some(val => val.value.trim())
    );

    if (validOptions.length === 0) {
      setVariants([]);
      return;
    }

    const combinations = [];
    
    const generateCombinations = (currentCombination, optionIndex) => {
      if (optionIndex >= validOptions.length) {
        combinations.push([...currentCombination]);
        return;
      }

      const currentOption = validOptions[optionIndex];
      const validValues = currentOption.values.filter(val => val.value.trim());
      
      for (const valueObj of validValues) {
        generateCombinations([...currentCombination, { 
          option: currentOption.name, 
          value: valueObj.value.trim(),
          optionData: valueObj
        }], optionIndex + 1);
      }
    };

    generateCombinations([], 0);

    const newVariants = combinations.map((combination, index) => {
      const existingVariant = variants.find(variant => 
        JSON.stringify(variant.combination.map(c => ({option: c.option, value: c.value}))) === 
        JSON.stringify(combination.map(c => ({option: c.option, value: c.value})))
      );

      const combinedPrice = combination.reduce((sum, c) => {
        const price = Number(c.optionData.price) || 0;
        return sum + price;
      }, 0) || Number(formFields.price) || 0;
      
      const combinedOldPrice = combination.reduce((sum, c) => {
        const oldPrice = Number(c.optionData.oldPrice) || 0;
        return sum + oldPrice;
      }, 0) || Number(formFields.oldPrice) || 0;
      
      const combinedStock = combination.reduce((sum, c) => {
        const stock = Number(c.optionData.stock) || 0;
        return sum + stock;
      }, 0);
      
      // Collect images from option values
      const combinedImages = combination.reduce((images, c) => {
        if (c.optionData.images && Array.isArray(c.optionData.images)) {
          return [...images, ...c.optionData.images];
        }
        return images;
      }, []);

      const autoDiscount = calculateDiscount(combinedPrice, combinedOldPrice);
      
      return existingVariant || {
        id: `variant_${Date.now()}_${index}`,
        combination,
        sku: `${formFields.name ? formFields.name.replace(/\s+/g, '-').toLowerCase() : 'product'}-${combination.map(c => c.value).join('-').toLowerCase()}`,
        price: combinedPrice,
        oldPrice: combinedOldPrice,
        countInStock: combinedStock,
        discount: autoDiscount,
        images: combinedImages,
        isActive: true,
        weight: '',
        dimensions: { length: 0, width: 0, height: 0 },
        minOrderQuantity: 1,
        maxOrderQuantity: 999,
        stockStatus: combinedStock > 0 ? 'in_stock' : 'out_of_stock',
        stockAlert: 10,
        barcode: '',
        notes: ''
      };
    });

    setVariants(newVariants);
  };

  // Form input handlers
 const handleChangeCategory = (event) => {
  const selectedCatId = event.target.value;

  setcategoryVal(selectedCatId);

  const selectedCategory = context.catData?.categoryList?.find(
    (cat) => cat._id === selectedCatId
  );

  // Set form fields
  setFormFields(prev => ({
    ...prev,
    category: selectedCatId,
    catName: selectedCategory?.name || "",
    catId: selectedCatId,
  }));

  // 🔥 FILTER SUBCATEGORIES HERE
  if (selectedCategory?.children) {
    setSubCatData(selectedCategory.children);
  } else {
    setSubCatData([]);
  }

  // Reset subcategory selection
  setSubCatVal("");
};

  const handleChangeSubCategory = (event) => {
    setSubCatVal(event.target.value);
  };

  const handleChangeProductRams = (event) => {
    const { target: { value } } = event;
    setProductRAMS(typeof value === "string" ? value.split(",") : value);
    formFields.productRam = value;
  };

  const handleChangeProductWeight = (event) => {
    const { target: { value } } = event;
    setProductWeight(typeof value === "string" ? value.split(",") : value);
    formFields.productWeight = value;
  };

  const handleChangeProductSize = (event) => {
    const { target: { value } } = event;
    setProductSize(typeof value === "string" ? value.split(",") : value);
    formFields.size = value;
  };

  const handleChangeisFeaturedValue = (event) => {
    setisFeaturedValue(event.target.value);
    setFormFields(prev => ({
      ...prev,
      isFeatured: event.target.value,
    }));
  };

  const inputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'name') {
      autoFillForm(value);
    }

    if (name === 'price' || name === 'oldPrice') {
      const currentPrice = name === 'price' ? Number(value) : Number(formFields.price);
      const mrp = name === 'oldPrice' ? Number(value) : Number(formFields.oldPrice);
      const autoDiscount = calculateDiscount(currentPrice, mrp);
      
      setFormFields(prev => ({
        ...prev,
        [name]: value,
        discount: autoDiscount
      }));
    } else {
      setFormFields(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const selectCat = (cat, id) => {
    formFields.catName = cat;
    formFields.catId = id;
  };

  const selectSubCat = (subCat, id) => {
    setFormFields(prev => ({
      ...prev,
      subCat: subCat,
      subCatName: subCat,
      subCatId: id,
    }));
  };

  // FIXED: Main product image upload
  const onChangeFile = async (e, apiEndPoint) => {
    try {
      const files = e.target.files;
      if (!files?.length) return;

      setUploading(true);

      const formdata = new FormData();

      const options = {
        maxSizeMB: 0.01,
        useWebWorker: true,
        alwaysKeepResolution: true,
        initialQuality: 0.3,
      };

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (
          file &&
          (file.type === 'image/jpeg' ||
            file.type === 'image/jpg' ||
            file.type === 'image/png' ||
            file.type === 'image/webp')
        ) {
          try {
            const compressedFile = await imageCompression(file, options);
            const renamedFile = new File(
              [compressedFile], 
              file.name || `image_${Date.now()}_${i}.${file.type.split('/')[1]}`, 
              { type: compressedFile.type }
            );
            formdata.append('images', renamedFile);
          } catch (compressionError) {
            console.error('Compression Error:', compressionError);
            context.setAlertBox({
              open: true,
              error: true,
              msg: 'Image compression failed.',
            });
            setUploading(false);
            return false;
          }
        } else {
          context.setAlertBox({
            open: true,
            error: true,
            msg: 'Please select a valid JPG or PNG image file.',
          });
          setUploading(false);
          return false;
        }
      }

      const res = await uploadImage(apiEndPoint, formdata);
      const response = await fetchDataFromApi('/api/imageUpload');
      
      if (response && response.length !== 0) {
        const img_arr = [];
        response.forEach((item) => {
          item?.images?.forEach((img) => {
            img_arr.push({
              id: item?._id,
              img: img,
            });
          });
        });

        const uniqueArray = img_arr.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.img === item.img)
        );

        // CRITICAL: Only update MAIN previews with proper structure
        setMainPreviews(uniqueArray);

        setTimeout(() => {
          setUploading(false);
          context.setAlertBox({
            open: true,
            error: false,
            msg: 'Main product images uploaded!',
          });
        }, 200);
      }
    } catch (error) {
      console.error('Upload Error:', error);
      setUploading(false);
      context.setAlertBox({
        open: true,
        error: true,
        msg: 'Upload failed. Please try again.',
      });
    }
  };

  // FIXED: Remove main product image
  const removeImg = async (indexToRemove, imgUrl, img_id) => {
    setIsImageRemove(true);

    try {
      console.log('Starting image deletion process:', { imgUrl, img_id, indexToRemove });

      // Step 1: Delete from Cloudinary first
      const deleteResponse = await deleteImages(`/api/products/deleteImage?img=${encodeURIComponent(imgUrl)}`);
      console.log('Cloudinary delete response:', deleteResponse);

      // Check if Cloudinary deletion was successful
      if (!deleteResponse || !deleteResponse.success) {
        throw new Error('Failed to delete from Cloudinary: ' + (deleteResponse?.message || 'Unknown error'));
      }

      // Step 2: Remove image URL from ImageUpload collection
      try {
        const deleteFromCollectionResponse = await deleteData(`/api/imageUpload/deleteImageUrl?img=${encodeURIComponent(imgUrl)}`);
        console.log('Collection delete response:', deleteFromCollectionResponse);
      } catch (collectionError) {
        console.warn('Failed to delete from collection, but continuing:', collectionError);
      }

      // Step 3: Update frontend state
      const updatedPreviews = mainPreviews.filter((_, index) => index !== indexToRemove);
      setMainPreviews(updatedPreviews);

      context.setAlertBox({
        open: true,
        error: false,
        msg: "Image deleted successfully!",
      });

      setIsImageRemove(false);
      
    } catch (error) {
      console.error('Error removing main image:', error);
      
      context.setAlertBox({
        open: true,
        error: true,
        msg: `Failed to delete image: ${error.message}`,
      });
      setIsImageRemove(false);
    }
  };

  // FIXED: Remove variant option image
  const removeOptionValueImage = async (optionIndex, valueIndex, imageIndex, imgUrl) => {
    try {
      console.log('Deleting variant option image:', { optionIndex, valueIndex, imageIndex, imgUrl });

      // Optimistically remove from local state
      const newOptions = [...variantOptions];
      newOptions[optionIndex].values[valueIndex].images.splice(imageIndex, 1);
      setVariantOptions(newOptions);
      generateVariants(newOptions);

      // Delete from Cloudinary
      const deleteResponse = await deleteImages(`/api/products/deleteImage?img=${encodeURIComponent(imgUrl)}`);
      console.log('Variant image delete response:', deleteResponse);

      context.setAlertBox({
        open: true,
        error: false,
        msg: "Variant image deleted successfully!"
      });
    } catch (error) {
      console.error('Error deleting variant option image:', error);
      
      // Restore image in case of error
      const restoredOptions = [...variantOptions];
      restoredOptions[optionIndex].values[valueIndex].images.splice(imageIndex, 0, imgUrl);
      setVariantOptions(restoredOptions);
      generateVariants(restoredOptions);

      context.setAlertBox({
        open: true,
        error: true,
        msg: "Failed to delete variant image. Please try again."
      });
    }
  };

  // ========== ALTERNATIVE PRODUCTS FUNCTIONS ==========

  // Load available products for alternatives
  const loadAvailableProducts = async () => {
    try {
      setLoadingAlternatives(true);
      const response = await fetchDataFromApi('/api/products');
      
      if (response && response.products) {
        // Filter out products that are already selected as alternatives
        const filteredProducts = response.products.filter(
          product => !alternativeProducts.some(alt => alt._id === product._id)
        );
        setAvailableProducts(filteredProducts);
      }
    } catch (error) {
      console.error('Error loading products:', error);
      context.setAlertBox({
        open: true,
        error: true,
        msg: "Failed to load products",
      });
    } finally {
      setLoadingAlternatives(false);
    }
  };

  // Open alternative products dialog
  const handleOpenAlternativeDialog = () => {
    loadAvailableProducts();
    setOpenAlternativeDialog(true);
  };

  // Close alternative products dialog
  const handleCloseAlternativeDialog = () => {
    setOpenAlternativeDialog(false);
    setSearchAlternative("");
  };

  // Add alternative product
  const handleAddAlternative = (product) => {
    if (alternativeProducts.some(p => p._id === product._id)) {
      // Already added, remove it
      const newAlternatives = alternativeProducts.filter(p => p._id !== product._id);
      setAlternativeProducts(newAlternatives);
      setAvailableProducts(prev => [...prev, product]);
      return;
    }

    const newAlternatives = [...alternativeProducts, product];
    setAlternativeProducts(newAlternatives);
    
    // Remove from available products
    setAvailableProducts(prev => prev.filter(p => p._id !== product._id));
    
    context.setAlertBox({
      open: true,
      error: false,
      msg: "Alternative product added successfully!",
    });
  };

  // Remove alternative product
  const handleRemoveAlternative = (productId) => {
    const removedProduct = alternativeProducts.find(p => p._id === productId);
    const newAlternatives = alternativeProducts.filter(p => p._id !== productId);
    setAlternativeProducts(newAlternatives);
    
    // Add back to available products if dialog is open
    if (removedProduct) {
      setAvailableProducts(prev => [...prev, removedProduct]);
    }
    
    context.setAlertBox({
      open: true,
      error: false,
      msg: "Alternative product removed",
    });
  };

  // Filter available products by search
  const filteredAvailableProducts = availableProducts.filter(product =>
    product.name.toLowerCase().includes(searchAlternative.toLowerCase()) ||
    product.brand?.toLowerCase().includes(searchAlternative.toLowerCase())
  );

  // =======================================================================

  // FIXED: Product submission
  const addProduct = (e) => {
    e.preventDefault();

    // Validation
    if (formFields.name === "") {
      context.setAlertBox({
        open: true,
        msg: "please add product name",
        error: true,
      });
      return false;
    }

    if (formFields.description === "") {
      context.setAlertBox({
        open: true,
        msg: "please add product description",
        error: true,
      });
      return false;
    }

    if (formFields.brand === "") {
      context.setAlertBox({
        open: true,
        msg: "please add product brand",
        error: true,
      });
      return false;
    }

    if (!hasVariants && formFields.price === null) {
      context.setAlertBox({
        open: true,
        msg: "please add product price",
        error: true,
      });
      return false;
    }

    if (!hasVariants && formFields.oldPrice === null) {
      context.setAlertBox({
        open: true,
        msg: "please add product oldPrice",
        error: true,
      });
      return false;
    }

    if (formFields.category === "") {
      context.setAlertBox({
        open: true,
        msg: "please select a category",
        error: true,
      });
      return false;
    }

    if (!hasVariants && formFields.countInStock === null) {
      context.setAlertBox({
        open: true,
        msg: "please add product count in stock",
        error: true,
      });
      return false;
    }

    if (formFields.rating === 0) {
      context.setAlertBox({
        open: true,
        msg: "please select product rating",
        error: true,
      });
      return false;
    }

    if (formFields.isFeatured === null) {
      context.setAlertBox({
        open: true,
        msg: "please select the product is a featured or not",
        error: true,
      });
      return false;
    }

    if (mainPreviews.length === 0) {
      context.setAlertBox({
        open: true,
        msg: "please select main product images",
        error: true,
      });
      return false;
    }

    // Enhanced Variant validation
    if (hasVariants) {
      if (variants.length === 0) {
        context.setAlertBox({
          open: true,
          msg: "please add at least one variant",
          error: true,
        });
        return false;
      }

      const activeVariants = variants.filter(v => v.isActive);
      if (activeVariants.length === 0) {
        context.setAlertBox({
          open: true,
          msg: "please activate at least one variant",
          error: true,
        });
        return false;
      }

      for (let variant of activeVariants) {
        if (!variant.price || variant.price <= 0) {
          context.setAlertBox({
            open: true,
            msg: `please set price for variant: ${variant.combination.map(c => c.value).join(', ')}`,
            error: true,
          });
          return false;
        }

        if (variant.countInStock === null || variant.countInStock < 0) {
          context.setAlertBox({
            open: true,
            msg: `please set stock for variant: ${variant.combination.map(c => c.value).join(', ')}`,
            error: true,
          });
          return false;
        }

        if (!variant.oldPrice || variant.oldPrice <= 0) {
          context.setAlertBox({
            open: true,
            msg: `please set MRP for variant: ${variant.combination.map(c => c.value).join(', ')}`,
            error: true,
          });
          return false;
        }
      }

      for (let option of variantOptions) {
        for (let value of option.values) {
          if (value.value.trim() && (!value.price || Number(value.price) <= 0)) {
            context.setAlertBox({
              open: true,
              msg: `please set price for option value: ${option.name} - ${value.value}`,
              error: true,
            });
            return false;
          }
          if (value.value.trim() && (!value.oldPrice || Number(value.oldPrice) <= 0)) {
            context.setAlertBox({
              open: true,
              msg: `please set MRP for option value: ${option.name} - ${value.value}`,
              error: true,
            });
            return false;
          }
        }
      }
    }

    // CRITICAL: Separate main product images from variant images
    const mainImageUrls = mainPreviews.map(img => img.img);
    
    formFields.images = mainImageUrls;
    formFields.location = selectedLocation;
    formFields.hasVariants = hasVariants;
    formFields.variantOptions = variantOptions;
    formFields.variants = variants;

    // ========== ADD ALTERNATIVE PRODUCTS ==========
    formFields.alternativeProducts = alternativeProducts.map((product, index) => ({
      productId: product._id,
      displayOrder: index
    }));
    // ==============================================

    console.log('Final form data - Main images:', mainImageUrls);
    console.log('Final form data - Variant data:', { variantOptions, variants });
    console.log('Final form data - Alternative Products:', formFields.alternativeProducts);

    setIsLoading(true);

    postData("/api/products/create", formFields).then((res) => {
      context.setAlertBox({
        open: true,
        msg: "The product is created successfully!",
        error: false,
      });

      setIsLoading(false);
      
      // Clean up all uploaded images from temporary storage
      deleteData("/api/imageUpload/deleteAllImages");

      history("/products");
    }).catch((error) => {
      console.error('Error creating product:', error);
      setIsLoading(false);
      context.setAlertBox({
        open: true,
        msg: "Failed to create product. Please try again.",
        error: true,
      });
    });
  };

  const handleChangeLocation = (selectedOptions) => {
    setSelectedLocation(selectedOptions);
  };

  const MAX_SPECIFICATIONS = 6;

  return (
    <>
      <div className="right-content w-100">
        <div className="card shadow border-0 w-100 flex-row p-4">
          <h5 className="mb-0">Product Upload</h5>
          <Breadcrumbs aria-label="breadcrumb" className="ml-auto breadcrumbs_">
            <StyledBreadcrumb
              component="a"
              href="#"
              label="Dashboard"
              icon={<HomeIcon fontSize="small" />}
            />
            <StyledBreadcrumb
              component="a"
              label="Products"
              href="#"
              deleteIcon={<ExpandMoreIcon />}
            />
            <StyledBreadcrumb
              label="Product Upload"
              deleteIcon={<ExpandMoreIcon />}
            />
          </Breadcrumbs>
        </div>

        <form className="form" onSubmit={addProduct}>
          <div className="row">
            <div className="col-md-12">
              <div className="card p-4 mt-0">
                <h5 className="mb-4">Basic Information</h5>

                <div className="form-group">
                  <h6>PRODUCT NAME</h6>
                  <input
                    type="text"
                    name="name"
                    value={formFields.name}
                    onChange={inputChange}
                    placeholder="Enter product name (auto-fills SKU and other fields)"
                  />
                </div>

                <div className="form-group">
                  <h6>DESCRIPTION</h6>
                  <textarea
                    rows={5}
                    cols={10}
                    value={formFields.description}
                    name="description"
                    onChange={inputChange}
                  />
                </div>

                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <h6>CATEGORY</h6>
                      <Select
                        value={categoryVal}
                        onChange={handleChangeCategory}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        className="w-100"
                      >
                        <MenuItem value="">
                          <em value={null}>None</em>
                        </MenuItem>
                        {context.catData?.categoryList?.length !== 0 &&
                          context.catData?.categoryList?.map((cat, index) => {
                            return (
                              <MenuItem
                                className="text-capitalize"
                                value={cat._id}
                                key={index}
                                onClick={() => selectCat(cat.name, cat._id)}
                              >
                                {cat.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6>SUB CATEGORY</h6>
                      <Select
                        value={subCatVal}
                        onChange={handleChangeSubCategory}
                        disabled={!categoryVal} 
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        className="w-100"
                      >
                        <MenuItem value="">
                          <em value={null}>None</em>
                        </MenuItem>
                        {subCatData?.length !== 0 &&
                          subCatData?.map((subCat, index) => {
                            return (
                              <MenuItem
                                className="text-capitalize"
                                value={subCat._id}
                                key={index}
                                onClick={() =>
                                  selectSubCat(subCat.name, subCat._id)
                                }
                              >
                                {subCat.name}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6>
                        PRICE 
                        {hasVariants && (
                          <Typography variant="caption" color="textSecondary" display="block">
                            (Base price - will be combined with variant prices)
                          </Typography>
                        )}
                      </h6>
                      <input
                        type="number"
                        name="price"
                        value={formFields.price}
                        onChange={inputChange}
                        placeholder="Current selling price"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <h6>
                        MRP 
                        {hasVariants && (
                          <Typography variant="caption" color="textSecondary" display="block">
                            (Base MRP - will be combined with variant MRPs)
                          </Typography>
                        )}
                      </h6>
                      <input
                        type="number"
                        name="oldPrice"
                        value={formFields.oldPrice}
                        onChange={inputChange}
                        placeholder="Maximum retail price"
                      />
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6>
                        PRODUCT STOCK 
                        {hasVariants && (
                          <Typography variant="caption" color="textSecondary" display="block">
                            (Individual variant stock will be used)
                          </Typography>
                        )}
                      </h6>
                      <input
                        type="number"
                        name="countInStock"
                        value={formFields.countInStock}
                        onChange={inputChange}
                        placeholder="Available quantity"
                      />
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6 className="text-uppercase">See in Front </h6>
                      <Select
                        value={isFeaturedValue}
                        onChange={handleChangeisFeaturedValue}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        className="w-100"
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                      </Select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <h6>BRAND</h6>
                      <input
                        type="text"
                        name="brand"
                        value={formFields.brand}
                        onChange={inputChange}
                      />
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6>DISCOUNT</h6>
                      <input
                        type="text"
                        name="discount"
                        value={formFields.discount}
                        onChange={inputChange}
                        placeholder="Auto-calculated from Price & MRP"
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6>PRODUCT RAMS</h6>
                      <Select
                        multiple
                        value={productRams}
                        onChange={handleChangeProductRams}
                        displayEmpty
                        className="w-100"
                        MenuProps={MenuProps}
                      >
                        {productRAMSData?.map((item, index) => {
                          return (
                            <MenuItem key={index} value={item.productRam}>
                              {item.productRam}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <h6>PRODUCT WEIGHT</h6>
                      <Select
                        multiple
                        value={productWeight}
                        onChange={handleChangeProductWeight}
                        displayEmpty
                        className="w-100"
                        MenuProps={MenuProps}
                      >
                        {productWEIGHTData?.map((item, index) => {
                          return (
                            <MenuItem
                              value={item.productWeight}
                              key={index}
                            >
                              {item.productWeight}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6>PRODUCT SIZE</h6>
                      <Select
                        multiple
                        value={productSize}
                        onChange={handleChangeProductSize}
                        displayEmpty
                        className="w-100"
                        MenuProps={MenuProps}
                      >
                        {productSIZEData?.map((item, index) => {
                          return (
                            <MenuItem value={item.size} key={index}>
                              {item.size}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  </div>

                  <div className="col">
                    <div className="form-group">
                      <h6>RATINGS</h6>
                      <Rating
                        name="simple-controlled"
                        value={ratingsValue}
                        onChange={(event, newValue) => {
                          setRatingValue(newValue);
                          setFormFields(prev => ({
                            ...prev,
                            rating: newValue,
                          }));
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* ========== ALTERNATIVE PRODUCTS SECTION ========== */}
                <div className="row mt-4">
                  <div className="col-12">
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="alternative-products-content"
                        id="alternative-products-header"
                      >
                        <Typography variant="h6">
                          <Box display="flex" alignItems="center" gap={1}>
                            <AiOutlineUnorderedList />
                            Alternative Products ({alternativeProducts.length})
                          </Box>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Alert severity="info" sx={{ mb: 2 }}>
                          Add alternative or similar products that customers might be interested in if this product is unavailable.
                        </Alert>
                        
                        {/* Display Selected Alternative Products */}
                        {alternativeProducts.length > 0 && (
                          <Box mb={3}>
                            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                              Selected Alternatives
                            </Typography>
                            <Stack direction="row" flexWrap="wrap" gap={1}>
                              {alternativeProducts.map((product) => (
                                <MuiChip
                                  key={product._id}
                                  label={product.name}
                                  onDelete={() => handleRemoveAlternative(product._id)}
                                  avatar={<Avatar src={product.images?.[0]} alt={product.name} />}
                                  color="primary"
                                  variant="outlined"
                                />
                              ))}
                            </Stack>
                          </Box>
                        )}

                        {/* Add Alternative Button */}
                        <Button
                          variant="contained"
                          startIcon={<MdAdd />}
                          onClick={handleOpenAlternativeDialog}
                          fullWidth
                          size="large"
                          sx={{ mt: 2 }}
                        >
                          Add Alternative Products
                        </Button>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
                {/* ======================================================= */}

                {/* YOUR REMAINING CODE CONTINUES HERE (variants, images, location, etc.) */}
                {/* I'm omitting the rest for brevity - all your existing code remains unchanged */}


                {/* Enhanced Variant Toggle */}
                <div className="row mt-4">
                  <div className="col-12">
                    <div className="form-group">
                      <FormControlLabel
                        control={
                          <Switch
                            checked={hasVariants}
                            onChange={handleVariantToggle}
                            color="primary"
                          />
                        }
                        label={
                          <Box display="flex" alignItems="center" gap={1}>
                            <FiPackage />
                            <Typography variant="h6">Enable Product Variants</Typography>
                          </Box>
                        }
                      />
                      <Typography variant="caption" color="textSecondary" display="block">
                        Create multiple variations with individual pricing, stock, and images for each option
                      </Typography>
                    </div>
                  </div>
                </div>

                {/* Enhanced Variant Options Section */}
                {hasVariants && (
                  <div className="row mt-4">
                    <div className="col-12">
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="variant-options-content"
                          id="variant-options-header"
                        >
                          <Typography variant="h6">
                            <Box display="flex" alignItems="center" gap={1}>
                              <MdEdit />
                              Variant Options with Auto-calculations
                            </Box>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Alert severity="info" sx={{ mb: 3 }}>
                            Set individual prices, stock, and images for each option value. Discounts are auto-calculated from MRP and current price.
                          </Alert>
                          
                          <Box>
                            {variantOptions.map((option, optionIndex) => (
                              <Card key={optionIndex} sx={{ mb: 3, border: '2px solid #e0e0e0', borderRadius: 2 }}>
                                <CardHeader
                                  title={
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                      <Typography variant="h6" color="primary">
                                        <FiPackage style={{ marginRight: 8 }} />
                                       Variant {optionIndex + 1}
                                      </Typography>
                                      {variantOptions.length > 1 && (
                                        <IconButton
                                          color="error"
                                          onClick={() => removeVariantOption(optionIndex)}
                                          sx={{ ml: 2 }}
                                        >
                                          <MdDelete />
                                        </IconButton>
                                      )}
                                    </Box>
                                  }
                                  sx={{ pb: 1, backgroundColor: '#f8f9fa' }}
                                />
                                <CardContent>
                                  <Box mb={3}>
                                    <Typography variant="body1" fontWeight="bold" gutterBottom color="text.primary">
                                      Variant Name 
                                    </Typography>
                                    <TextField
                                      fullWidth
                                      placeholder="e.g., Color, Size, Material"
                                      value={option.name}
                                      onChange={(e) => updateVariantOptionName(optionIndex, e.target.value)}
                                      variant="outlined"
                                      size="medium"
                                    />
                                  </Box>

                                  <Typography variant="body1" fontWeight="bold" gutterBottom color="text.primary">
                                    Variant Values & Settings
                                  </Typography>
                                  
                                  {option.values.map((valueObj, valueIndex) => (
                                    <Card key={valueIndex} sx={{ mb: 3, border: '1px solid #ddd', borderRadius: 2, backgroundColor: '#fafafa' }}>
                                      <CardHeader
                                        title={
                                          <Box display="flex" alignItems="center" justifyContent="space-between">
                                            <Typography variant="subtitle1" color="secondary">
                                              <BiMoney style={{ marginRight: 8 }} />
                                              Value {valueIndex + 1}
                                            </Typography>
                                            {option.values.length > 1 && (
                                              <IconButton
                                                color="error"
                                                size="small"
                                                onClick={() => removeVariantOptionValue(optionIndex, valueIndex)}
                                              >
                                                <IoCloseSharp />
                                              </IconButton>
                                            )}
                                          </Box>
                                        }
                                        sx={{ pb: 1, backgroundColor: '#ffffff' }}
                                      />
                                      <CardContent>
                                        <Grid container spacing={3}>
                                          {/* Value Name */}
                                          <Grid item xs={12} md={6}>
                                            <TextField
                                              fullWidth
                                              label="Variant Name "
                                              placeholder="e.g., Red, Large, Cotton"
                                              value={valueObj.value}
                                              onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'value', e.target.value)}
                                              variant="outlined"
                                              size="small"
                                              required
                                            />
                                          </Grid>
                                          
                                          {/* Auto-generated SKU */}
                                          <Grid item xs={12} md={6}>
                                            <TextField
                                              fullWidth
                                              label="SKU (Auto-generated)"
                                              value={valueObj.sku}
                                              onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'sku', e.target.value)}
                                              variant="outlined"
                                              size="small"
                                              InputProps={{
                                                style: { backgroundColor: '#f5f5f5' }
                                              }}
                                            />
                                          </Grid>

                                          {/* Pricing Section */}
                                          <Grid item xs={12} md={4}>
                                            <TextField
                                              fullWidth
                                              label="Current Price "
                                              type="number"
                                              value={valueObj.price}
                                              onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'price', e.target.value)}
                                              variant="outlined"
                                              size="small"
                                              required
                                              InputProps={{
                                                startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                              }}
                                              placeholder="0"
                                            />
                                          </Grid>
                                          
                                          <Grid item xs={12} md={4}>
                                            <TextField
                                              fullWidth
                                              label="MRP (Old Price) "
                                              type="number"
                                              value={valueObj.oldPrice}
                                              onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'oldPrice', e.target.value)}
                                              variant="outlined"
                                              size="small"
                                              required
                                              InputProps={{
                                                startAdornment: <InputAdornment position="start">₹</InputAdornment>,
                                              }}
                                              placeholder="0"
                                            />
                                          </Grid>
                                          
                                          <Grid item xs={12} md={4}>
                                            <TextField
                                              fullWidth
                                              label="Stock Quantity "
                                              type="number"
                                              value={valueObj.stock}
                                              onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'stock', e.target.value)}
                                              variant="outlined"
                                              size="small"
                                              required
                                              InputProps={{
                                                endAdornment: <InputAdornment position="end">units</InputAdornment>,
                                              }}
                                              placeholder="0"
                                            />
                                          </Grid>

                                          {/* Auto-calculated Discount Display */}
                                          <Grid item xs={12} md={6}>
                                            <Box display="flex" alignItems="center" gap={2}>
                                              <FormControlLabel
                                                control={
                                                  <Switch
                                                    checked={valueObj.isActive}
                                                    onChange={(e) => updateVariantOptionValue(optionIndex, valueIndex, 'isActive', e.target.checked)}
                                                    color="primary"
                                                    size="small"
                                                  />
                                                }
                                                label="Active"
                                              />
                                              <MuiChip 
                                                label={`${valueObj.discount || 0}% OFF`}
                                                color={valueObj.discount > 0 ? 'success' : 'default'}
                                                size="small"
                                                variant="outlined"
                                                sx={{ fontWeight: 'bold' }}
                                              />
                                            </Box>
                                          </Grid>

                                          <Grid item xs={12} md={6}>
                                            {/* Price Summary */}
                                            {valueObj.price && valueObj.oldPrice && Number(valueObj.price) > 0 && Number(valueObj.oldPrice) > Number(valueObj.price) && (
                                              <Box>
                                                <Typography variant="caption" color="success.main" fontWeight="bold">
                                                  Save: ₹{(Number(valueObj.oldPrice) - Number(valueObj.price)).toFixed(2)}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary" display="block">
                                                  ({valueObj.discount}% off)
                                                </Typography>
                                              </Box>
                                            )}
                                          </Grid>

                                          {/* FIXED: Images Section - Only variant images */}
                                          <Grid item xs={12}>
                                            <Box>
                                              <Typography variant="subtitle2" gutterBottom fontWeight="bold">
                                                <Box display="flex" alignItems="center" gap={1}>
                                                  <MdImage />
                                                  Variant Images (Separate from Main)
                                                  <Badge badgeContent={valueObj.images?.length || 0} color="primary">
                                                    <FiCamera />
                                                  </Badge>
                                                </Box>
                                              </Typography>
                                              
                                              <Grid container spacing={1} sx={{ mt: 1 }}>
                                                {valueObj.images?.map((imgUrl, imgIndex) => (
                                                  <Grid item xs={3} sm={2} md={1} key={imgIndex}>
                                                    <Box position="relative">
                                                      <LazyLoadImage
                                                        alt={`${valueObj.value}-${imgIndex}`}
                                                        effect="blur"
                                                        src={imgUrl}
                                                        style={{ 
                                                          width: '100%', 
                                                          height: 70, 
                                                          objectFit: 'cover', 
                                                          borderRadius: 8,
                                                          border: '2px solid #ddd',
                                                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                        }}
                                                      />
                                                      <IconButton
                                                        size="small"
                                                        color="error"
                                                        sx={{ 
                                                          position: 'absolute', 
                                                          top: -8, 
                                                          right: -8,
                                                          background: 'white',
                                                          width: 24,
                                                          height: 24,
                                                          '&:hover': { background: '#ffebee' },
                                                          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                        }}
                                                        onClick={() => removeOptionValueImage(optionIndex, valueIndex, imgIndex, imgUrl)}
                                                      >
                                                        <IoCloseSharp style={{ fontSize: 14 }} />
                                                      </IconButton>
                                                    </Box>
                                                  </Grid>
                                                ))}
                                                
                                                <Grid item xs={3} sm={2} md={1}>
                                                  <Box
                                                    sx={{
                                                      height: 70,
                                                      border: '2px dashed #ccc',
                                                      borderRadius: 2,
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      cursor: 'pointer',
                                                      backgroundColor: '#f9f9f9',
                                                      '&:hover': { 
                                                        borderColor: '#1976d2',
                                                        backgroundColor: '#e3f2fd'
                                                      },
                                                      transition: 'all 0.3s ease'
                                                    }}
                                                    component="label"
                                                  >
                                                    {uploadingOptionImages[`${optionIndex}-${valueIndex}`] ? (
                                                      <CircularProgress size={20} />
                                                    ) : (
                                                      <BiImageAdd size={28} color="#1976d2" />
                                                    )}
                                                    <input
                                                      type="file"
                                                      multiple
                                                      hidden
                                                      accept="image/*"
                                                      onChange={(e) => onChangeOptionValueFile(e, optionIndex, valueIndex)}
                                                    />
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                              
                                              <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                                                Upload images specific to this variant value (separate from main gallery)
                                              </Typography>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </CardContent>
                                    </Card>
                                  ))}
                                  
                                  <Button
                                    variant="outlined"
                                    startIcon={<MdAdd />}
                                    onClick={() => addVariantOptionValue(optionIndex)}
                                    sx={{ 
                                      mt: 2, 
                                      borderStyle: 'dashed',
                                      '&:hover': {
                                        borderStyle: 'solid',
                                        backgroundColor: 'primary.light'
                                      }
                                    }}
                                    fullWidth
                                  >
                                    Add Another Value
                                  </Button>
                                </CardContent>
                              </Card>
                            ))}
                            
                            <Button
                              variant="contained"
                              startIcon={<MdAdd />}
                              onClick={addVariantOption}
                              size="large"
                              sx={{ 
                                mt: 2,
                                py: 1.5,
                                fontSize: '1.1rem',
                                boxShadow: '0 4px 8px rgba(25, 118, 210, 0.3)',
                                '&:hover': {
                                  boxShadow: '0 6px 12px rgba(25, 118, 210, 0.4)',
                                }
                              }}
                              fullWidth
                            >
                              Add New Variant Option
                            </Button>
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                )}

                {/* Generated Variants Display */}
                {hasVariants && variants.length > 0 && (
                  <div className="row mt-4">
                    <div className="col-12">
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="generated-variants-content"
                          id="generated-variants-header"
                        >
                          <Typography variant="h6">
                            <Box display="flex" alignItems="center" gap={1}>
                              <MdInventory />
                              Generated Variants ({variants.length}) - Auto-calculated
                            </Box>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Alert severity="success" sx={{ mb: 3 }}>
                            These variants are automatically generated from your option combinations. Prices, stock, and discounts are auto-calculated.
                          </Alert>
                          
                          <TableContainer component={Paper} elevation={3}>
                            <Table size="small">
                              <TableHead>
                                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                  <TableCell><strong>Active</strong></TableCell>
                                  <TableCell><strong>Combination</strong></TableCell>
                                  <TableCell><strong>Price</strong></TableCell>
                                  <TableCell><strong>MRP</strong></TableCell>
                                  <TableCell><strong>Discount</strong></TableCell>
                                  <TableCell><strong>Stock</strong></TableCell>
                                  <TableCell><strong>Images</strong></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {variants.map((variant) => (
                                  <TableRow key={variant.id} hover>
                                    <TableCell>
                                      <Switch
                                        checked={variant.isActive}
                                        size="small"
                                        color="primary"
                                        readOnly
                                      />
                                    </TableCell>
                                    
                                    <TableCell>
                                      <Box>
                                        <Typography variant="body2" fontWeight="bold">
                                          {variant.combination.map(c => c.value).join(' + ')}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                          {variant.combination.map(c => `${c.option}: ${c.value}`).join(' | ')}
                                        </Typography>
                                      </Box>
                                    </TableCell>
                                    
                                    <TableCell>
                                      <Typography variant="body2" color="primary" fontWeight="bold">
                                        ₹{variant.price?.toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                    
                                    <TableCell>
                                      <Typography variant="body2" color="textSecondary">
                                        ₹{variant.oldPrice?.toFixed(2)}
                                      </Typography>
                                    </TableCell>

                                    <TableCell>
                                      <MuiChip 
                                        label={`${variant.discount || 0}% OFF`}
                                        color={variant.discount > 0 ? 'success' : 'default'}
                                        size="small"
                                        variant="filled"
                                      />
                                    </TableCell>
                                    
                                    <TableCell>
                                      <MuiChip 
                                        label={`${variant.countInStock} units`}
                                        color={variant.countInStock > 0 ? 'success' : 'error'}
                                        size="small"
                                        variant="outlined"
                                      />
                                    </TableCell>
                                    
                                    <TableCell>
                                      <Box display="flex" flexWrap="wrap" gap={0.5}>
                                        {variant.images?.slice(0, 3).map((imgUrl, imgIndex) => (
                                          <LazyLoadImage
                                            key={imgIndex}
                                            alt={`variant-${variant.id}-${imgIndex}`}
                                            effect="blur"
                                            src={imgUrl}
                                            style={{ 
                                              width: 35, 
                                              height: 35, 
                                              objectFit: 'cover', 
                                              borderRadius: 6,
                                              border: '1px solid #ddd'
                                            }}
                                          />
                                        ))}
                                        {variant.images?.length > 3 && (
                                          <Box 
                                            sx={{ 
                                              width: 35, 
                                              height: 35, 
                                              display: 'flex', 
                                              alignItems: 'center', 
                                              justifyContent: 'center',
                                              backgroundColor: '#f0f0f0',
                                              borderRadius: 1,
                                              fontSize: '10px',
                                              border: '1px solid #ddd'
                                            }}
                                          >
                                            +{variant.images.length - 3}
                                          </Box>
                                        )}
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                )}

                {/* Add specification */}
                <div className="row mt-4">
                  <div className="col">
                    <h6 className="section-title mb-3">ADD SPECIFICATION</h6>
                    {formFields.specification.map((item, index) => (
                      <div className="row mb-2 align-items-center" key={index}>
                        <div className="col-md-5">
                          <input
                            type="text"
                            className="form-control info-input"
                            placeholder="Custom Key..."
                            value={item.key}
                            onChange={(e) => {
                              const newInfo = [...formFields.specification];
                              newInfo[index].key = e.target.value;
                              setFormFields({ ...formFields, specification: newInfo });
                            }}
                          />
                        </div>
                        <div className="col-md-5">
                          <input
                            type="text"
                            className="form-control info-input"
                            placeholder="Custom Value..."
                            value={item.value}
                            onChange={(e) => {
                              const newInfo = [...formFields.specification];
                              newInfo[index].value = e.target.value;
                              setFormFields({ ...formFields, specification: newInfo });
                            }}
                          />
                        </div>
                        <div className="col-auto">
                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            className="remove-btn"
                            onClick={() => {
                              const newInfo = [...formFields.specification];
                              newInfo.splice(index, 1);
                              setFormFields({ ...formFields, specification: newInfo });
                            }}
                          >
                            <IoCloseSharp />
                          </Button>
                        </div>
                      </div>
                    ))}

                    {formFields.specification.length < MAX_SPECIFICATIONS && (
                      <Button
                        variant="contained"
                        className="add-more-btn mt-2"
                        onClick={() =>
                          setFormFields({
                            ...formFields,
                            specification: [...formFields.specification, { key: "", value: "" }],
                          })
                        }
                      >
                        Add specification
                      </Button>
                    )}

                    {formFields.specification.length >= MAX_SPECIFICATIONS && (
                      <p className="text-muted mt-2">Maximum of 6 specifications allowed.</p>
                    )}
                  </div>
                </div>

                {/* additional info */}
                <div className="row mt-4">
                  <div className="col">
                    <h6 className="section-title mb-3">ADDITIONAL INFO</h6>
                    {formFields.additionalInfo.map((item, index) => (
                      <div className="row mb-2 align-items-center" key={index}>
                        <div className="col-md-5">
                          <input
                            type="text"
                            className="form-control info-input"
                            placeholder="Custom Key..."
                            value={item.key}
                            onChange={(e) => {
                              const newInfo = [...formFields.additionalInfo];
                              newInfo[index].key = e.target.value;
                              setFormFields({ ...formFields, additionalInfo: newInfo });
                            }}
                          />
                        </div>
                        <div className="col-md-5">
                          <input
                            type="text"
                            className="form-control info-input"
                            placeholder="Custom Value..."
                            value={item.value}
                            onChange={(e) => {
                              const newInfo = [...formFields.additionalInfo];
                              newInfo[index].value = e.target.value;
                              setFormFields({ ...formFields, additionalInfo: newInfo });
                            }}
                          />
                        </div>
                        <div className="col-auto">
                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            className="remove-btn"
                            onClick={() => {
                              const newInfo = [...formFields.additionalInfo];
                              newInfo.splice(index, 1);
                              setFormFields({ ...formFields, additionalInfo: newInfo });
                            }}
                          >
                            <IoCloseSharp />
                          </Button>
                        </div>
                      </div>
                    ))}
                    <Button
                      variant="contained"
                      className="add-more-btn mt-2"
                      onClick={() =>
                        setFormFields({
                          ...formFields,
                          additionalInfo: [...formFields.additionalInfo, { key: "", value: "" }],
                        })
                      }
                    >
                      Add More Info
                    </Button>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <h6>LOCATION</h6>
                      <Select2
                        isMulti
                        name="location"
                        options={countryList}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={handleChangeLocation}
                      />
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <div className="card p-4 mt-0">
            <div className="imagesUploadSec">
              <h5 className="mb-4">Main Product Images</h5>
              <Alert severity="warning" sx={{ mb: 2 }}>
                These are the main product gallery images. Variant images are uploaded separately above.
              </Alert>

              <div className="imgUploadBox d-flex align-items-center">
                {mainPreviews?.length !== 0 && mainPreviews?.map((img, index) => (
                  <div className='uploadBox' key={index}>
                    <span 
                      className="remove" 
                      style={{ 
                        pointerEvents: isImageRemove ? 'none' : 'auto',
                        opacity: isImageRemove ? 0.5 : 1 
                      }}
                      onClick={() => removeImg(index, img?.img, img?.id)}
                    >
                      <IoCloseSharp />
                    </span>
                    <div className='box'>
                      <LazyLoadImage
                        alt={"main-product-image"}
                        effect="blur"
                        className="w-100"
                        src={img?.img} 
                      />
                    </div>
                  </div>
                ))}

                <div className="uploadBox">
                  {uploading === true ? (
                    <div className="progressBar text-center d-flex align-items-center justify-content-center flex-column">
                      <CircularProgress />
                      <span>Uploading Main Images...</span>
                    </div>
                  ) : (
                    <>
                      <input
                        type="file"
                        multiple
                        onChange={(e) =>
                          onChangeFile(e, "/api/products/upload")
                        }
                        name="images"
                        accept="image/*"
                      />
                      <div className="info">
                        <FaRegImages />
                        <h5>Upload Main Images</h5>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <br />

              <div className="floating-btn-wrapper">
                <Button
                  type="submit"
                  disabled={uploading === true}
                  className="btn-blue btn-lg btn-big"
                >
                  <FaCloudUploadAlt /> &nbsp;
                  {isLoading ? (
                    <CircularProgress color="inherit" className="loader" />
                  ) : (
                    "PUBLISH AND VIEW"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>

      {/* ========== ALTERNATIVE PRODUCTS DIALOG ========== */}
      <Dialog
        open={openAlternativeDialog}
        onClose={handleCloseAlternativeDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6">
              <AiOutlineUnorderedList style={{ marginRight: 8 }} />
              Select Alternative Products
            </Typography>
            <IconButton onClick={handleCloseAlternativeDialog}>
              <IoCloseSharp />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {/* Search Box */}
          <TextField
            fullWidth
            placeholder="Search by product name or brand..."
            value={searchAlternative}
            onChange={(e) => setSearchAlternative(e.target.value)}
            sx={{ mb: 2 }}
            variant="outlined"
            size="small"
          />

          {/* Loading State */}
          {loadingAlternatives && (
            <Box display="flex" justifyContent="center" py={4}>
              <CircularProgress />
            </Box>
          )}

          {/* Available Products List */}
          {!loadingAlternatives && (
            <List sx={{ maxHeight: 400, overflow: 'auto' }}>
              {filteredAvailableProducts.length === 0 ? (
                <Alert severity="info">No products available</Alert>
              ) : (
                filteredAvailableProducts.map((product) => (
                  <ListItem
                    key={product._id}
                    sx={{
                      border: '1px solid #e0e0e0',
                      borderRadius: 1,
                      mb: 1,
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: '#f5f5f5'
                      }
                    }}
                    onClick={() => handleAddAlternative(product)}
                  >
                    <ListItemAvatar>
                      <Avatar
                        src={product.images?.[0]}
                        alt={product.name}
                        variant="rounded"
                        sx={{ width: 60, height: 60 }}
                      />
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography variant="body1" fontWeight="bold">
                          {product.name}
                        </Typography>
                      }
                      secondary={
                        <Box>
                          <Typography variant="caption" color="textSecondary">
                            Brand: {product.brand}
                          </Typography>
                          <br />
                          <Typography variant="caption" color="primary" fontWeight="bold">
                            ₹{product.price} {product.oldPrice && `(MRP: ₹${product.oldPrice})`}
                          </Typography>
                        </Box>
                      }
                    />
                    <ListItemSecondaryAction>
                      <Checkbox
                        edge="end"
                        checked={alternativeProducts.some(p => p._id === product._id)}
                        onChange={() => handleAddAlternative(product)}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                ))
              )}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlternativeDialog} color="primary">
            Done
          </Button>
        </DialogActions>
      </Dialog>
      {/* ====================================================== */}
    </>
  );
};

export default ProductUpload;
